import spinner from '../utils/rbmc.spinner';
import cookieUtils from '../utils/rbmc.cookie-utils';

const OIDC_LOGIN_SCREEN = 'gigya-oidc-login-screen',
      GIGYA_SITE        = 'site';

const gigyaOidc = {

    bindHandler() {
        //add events listeners
        // TODO: sometimes happens that the event was already triggered. Then the listener will not fire again
        // For the moment eventListener was added as inline script to accountLoginPage.jsp and checkoutLoginPage.jsp
        // document.addEventListener('oidc-after-screen-load', gigyaOidc.oicdAddBtnLabels);
        document.addEventListener('oidc-after-screen-load', gigyaOidc.hideOtherButtons);
        window.gigya.accounts.getAccountInfo({callback: gigyaOidc.cdcUserIdentityHandler});
        gigyaOidc.bindEvents();
    },

    oicdAddBtnLabels(evt) {
        if (evt.detail.currentScreen === OIDC_LOGIN_SCREEN) {
            const $OIDC_LOGIN_CONTAINER = $('#cdc-oidc-login-page-container');
            if (RedBull.i18n && RedBull.i18n.oidc && RedBull.i18n.oidc.labels.length) {
                RedBull.i18n.oidc.labels.forEach((item) => {
                    // after-screen-load doesn't mean that the buttons are already there
                    setTimeout(function () {
                        const labelText = item.value;
                        const label     = `<div class="oidc-label">${labelText}</div>`;
                        $OIDC_LOGIN_CONTAINER.find('[gigid="' + item.id + '"]').after(label);
                    }, 250);
                });
            }
        }
    },

    cdcUserIdentityHandler(userData) {
        const profileNavPassReset = $('#profile-password-change'),
              profileNav          = $('.account-navigation__container'),
              loginProvider       = userData.loginProvider;
        if (loginProvider !== GIGYA_SITE) {
            profileNavPassReset.remove();
        }
        profileNav.fadeIn({duration: 100});
    },

    onOidcAfterScreenSubmit: function (event) {
        spinner.spinnerVisibility(true);
    },

    hideOtherButtons(evt) {
        const subShop = cookieUtils.getFirstCookieValue('subShop');
        //now just set the subshop in dom, because the buttons are not yet added
        if (evt.detail.currentScreen === OIDC_LOGIN_SCREEN) {
            $('#cdc-oidc-login-page-container').attr('subshop', subShop);
        }
    },

    bindEvents: function () {
        document.addEventListener('oidc-after-screen-submit', gigyaOidc.onOidcAfterScreenSubmit);
    }
}

export default gigyaOidc;
